// extracted by mini-css-extract-plugin
export default {"toolbar":"Header_toolbar__aeRX5","toolbarLogo":"Header_toolbarLogo__Dh7sM"};